<template>
  <!-- This div should actually be a section tag, but that causes hydration errors. -->
  <section class="container">
    <span v-html="title"></span>

    <div id="faqs-container">
      <ShopFaqItem
        :question="faq.question"
        :answer="faq.answer"
        v-for="faq in faqs"
      />
    </div>
  </section>
</template>
<script setup lang="ts">
/** The FAQ  section for a shop, a lot in the FAQ block is using `v-html`, because the content is inserted as rich text from the backend.
 */

const props = defineProps<{
  title: string;
  faqs: Array<{ question: string; answer: string }>;
}>();

// Define the Schema.org structure for the shop page.
const jsonLD = computed(() => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: props.faqs.map((faq: { question: string; answer: string }) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
}));

useHead({
  script: [
    {
      hid: "faqs-json-ld",
      type: "application/ld+json",
      children: JSON.stringify(jsonLD.value),
      tagPosition: "bodyClose",
    },
  ],
});
</script>
<style>
#faqs-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
